import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ReturnOrderService} from '../../services/return-order.service';
import {Router} from '@angular/router';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface CheckResponse {
  code: number;
  message: string;
}

@Component({
  templateUrl: './edit-return-order-serial-number.component.html'
})
export class EditReturnOrderSerialNumberComponent {
  title: string;
  newSerialNumber: string;
  validSerialNumber: boolean;
  details: any;
  isLoading: boolean;
  isUpdating: boolean;
  checkResponse: CheckResponse;
  proceed: boolean;

  constructor(private matDialogRef: MatDialogRef<EditReturnOrderSerialNumberComponent>,
              private returnOrderService: ReturnOrderService,
              private router: Router,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.validSerialNumber = false;
    this.details = data.details;
    this.isLoading = false;
    this.proceed = false;
    this.isUpdating = false;
  }

  close(value?) {
    this.matDialogRef.close(value);
  }

  async checkSerialNumber() {
    try {
      this.isLoading = true;
      if (this.details.newSerialNumber === this.newSerialNumber) {
        this.toastMessagesService.toastMessages('Προσπαθείτε να εισάγετε τον ίδιο σειριακό αριθμό.');
        return;
      }
      const model = {
        newSerialNumber: this.newSerialNumber,
        id: this.details.id
      };

      this.checkResponse = await this.returnOrderService.checkSerialNumber(model) as CheckResponse;

      // ο σειριακός δε μπορεί να εισαχθεί
      if (this.checkResponse.code === 1) {
        this.toastMessagesService.toastMessages(this.checkResponse.message);
        // this.close();
      }

      // ο σειριακός μπορεί να εισαχθεί
      if (this.checkResponse.code === 2) {
        this.proceed = true;
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  isDisabled() {
    if (this.isUpdating) {
      return true;
    } else {
      return !(this.proceed && this.checkResponse.code === 2);
    }
  }

  async updateSerialNumber() {
    try {
      this.isUpdating = true;
      const model = {
        newSerialNumber: this.newSerialNumber,
        id: this.details.id
      };
      await this.returnOrderService.updateSerialNumber(model);
      await this.router.navigate(['returns']);

      this.close(true);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isUpdating = false;
    }
  }
}
